<template>
  <div class="benefits-container">
    <!-- Desplazamiento infinito sin cortes -->
    <div class="benefit-box d-flex ">
      <div class="benefits-wrapper scroll-animation">
        <div
          v-for="(benefit, i) in repeatedBenefits"
          :key="i"
          class="benefit"
        >
          <span class="icon">{{ benefit.icon }}</span>
          <p class="text">
            {{ benefit.text }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ScrollableBenefits',
  computed: {
    benefits() {
      return [
        { icon: '🌎', text: this.$t('lang.home.benefits.locations') },
        { icon: '🔒', text: this.$t('lang.home.benefits.security') },
        { icon: '🆓', text: this.$t('lang.home.benefits.cancellation') },
        { icon: '⭐', text: this.$t('lang.home.benefits.reputation') },
        { icon: '☑️', text: this.$t('lang.home.benefits.stores') },
      ];
    },
    // Duplicamos los elementos para que el scroll nunca se detenga
    repeatedBenefits() {
      const array = this.benefits;
      return [...array, ...array, ...array];
    },
  },
};
</script>

<style scoped>
.benefits-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  overflow: hidden;
  margin-top: 2rem;
  background: rgba(255, 255, 255, 0.15);
}

.benefit-box {
  width: 100%;
  position: relative;
  overflow: hidden;
}

/* 🔹 Desktop: Sin animación */
.benefits-wrapper {
  display: inline-flex;
  gap: 50px;
  white-space: nowrap;
}

/* 🔹 Mobile: Animación infinita sin cortes */
.scroll-animation {
  display: inline-flex;
  gap: 50px;
  animation: scroll-left 30s linear infinite;
  width: max-content; /* Ajuste dinámico para evitar cortes */
  animation-delay: 2s;
}

/* 🔹 Animación infinita */
@keyframes scroll-left {
  from {
    transform: translateX(0%);
  }
  to {
    transform: translateX(-50%);
  }
}

.benefit {
  display: inline-flex;
  align-items: center;
  border-radius: 8px;
  min-width: 160px; /* Asegurar tamaño uniforme */
  padding: 5px;
  white-space: nowrap;
  max-height: 40px;
  margin-left: 15px;
}

/* Icono */
.icon {
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
}

/* Texto */
.benefit p.text {
  font-weight: bold;
  font-size: 14px;
  margin: 0;
}
</style>
